import { paymentMethodsActions } from 'src/store/api/paymentMethods/actions';
import { IPaymentMethod } from 'src/store/api/paymentMethods/types';
import { createReducer } from '@reduxjs/toolkit';

const initialState: { entities: IPaymentMethod[]; totalCount: number } = {
  entities: [],
  totalCount: 0,
};

export const paymentMethodsReducer = createReducer(initialState, (builder) => {
  builder.addCase(paymentMethodsActions.getMany.fulfilled, (state, action) => {
    if (!action.payload) {
      return;
    }

    state.totalCount = action.payload.totalElements;
    state.entities = action.payload.content;
  });
});
